<template>
  <svg
    aria-hidden="true"
    data-name="001-facebook"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
  >
    <path
      d="M45 5.9v33.214c-.033.11-.066.22-.088.33a6.4 6.4 0 0 1-3.654 4.874A15.389 15.389 0 0 1 39.1 45H27.766V29.091h6.68c.44-2.641.88-5.248 1.321-7.922h-7.979v-5.347h7.946v-7.9c-2.619 0-5.216-.011-7.8 0a7.92 7.92 0 0 0-8.067 8.065V21.2h-5.252v7.9h5.249V45H5.888a1.174 1.174 0 0 0-.209-.077A6.562 6.562 0 0 1 0 38.322Q0 22.511.022 6.69A7.015 7.015 0 0 1 .374 4.5 6.531 6.531 0 0 1 6.779.012H36.6c.671 0 1.354-.033 2.025.011A6.407 6.407 0 0 1 44.3 3.7a14.657 14.657 0 0 1 .7 2.2Z"
      fill="#0a2d73"
    />
    <path
      data-name="Path"
      d="M20.212 45V29.137H15v-7.882h5.212v-5.2A7.876 7.876 0 0 1 28.221 8c2.568-.011 5.146 0 7.747 0v7.887h-7.889v5.335H36c-.437 2.668-.874 5.269-1.311 7.9h-6.632V45Z"
      fill="#fff"
    />
    <path
      data-name="Path"
      d="M45 5.955a14.639 14.639 0 0 0-.7-2.2A6.377 6.377 0 0 0 38.639.088C37.969.044 37.3.077 36.617.077H6.844A6.52 6.52 0 0 0 .45 4.559 7.058 7.058 0 0 0 .1 6.746Q.066 22.533.088 38.331a6.536 6.536 0 0 0 5.669 6.592.98.98 0 0 1 .209.077H0V0h45ZM39 45a14.684 14.684 0 0 0 2.194-.7 6.543 6.543 0 0 0 3.716-4.964c.023-.112.056-.224.09-.336v6Z"
      fill="#fff"
    />
  </svg>
</template>
